import CardActions from '@mui/material/CardActions';
import RefreshDate from '@src/main/ui/components/common/Dashboard/common/footer/RefreshDate/RefreshDate';
import Views from '@src/main/ui/components/common/Dashboard/common/footer/Views/Views';
import { FC } from 'react';

interface DashboardCardResumeFooterProps {
  refreshDate?: Date;
  views?: number;
}

const defaultProps = { refreshDate: undefined, views: undefined };

const DashboardCardResumeFooter: FC<DashboardCardResumeFooterProps> = ({ refreshDate, views }) => (
  <CardActions disableSpacing sx={{ padding: '13px 16px', marginRight: 8 }}>
    <RefreshDate refreshDate={refreshDate} variant="small" />
    <Views views={views} variant="small" />
  </CardActions>
);

DashboardCardResumeFooter.defaultProps = defaultProps;

export default DashboardCardResumeFooter;
